import React from 'react';
import PropTypes from 'prop-types';

class FilterInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: props.initialValue, }
    }

    handleChange(event) {
        const value = event.target.value;
        this.setState({ value });
        this.props.onChange(value);
    }

    render() {
        const { label, inputProps } = this.props;
        const inputName = 'input-filter';
        return (
            <div className="input-filter inline">
                {label && [
                    <label key="input-filter-label-1" htmlFor={inputName}>{label}</label>,
                    <br key="input-filter-label-2"/>,
                ]}
                <input
                    name={inputName}
                    className="form-control"
                    onChange={this.handleChange.bind(this)}
                    value={this.state.value}
                    {...inputProps}
                />
            </div>
        )
    }
}

FilterInput.propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func.isRequired,
    inputProps: PropTypes.object,
};

FilterInput.defaultProps = {
    initialValue: null,
    inputProps: {},
};

export default FilterInput



// WEBPACK FOOTER //
// ./src/components/Filters/Input/index.js